import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';

const PageContainer = ({ id, children, sx, xs = 10, sm = 8, md = 6, lg = 5, dataAutomationId }) => (
    <Box
        id={id}
        {...((dataAutomationId || id) ? { 'data-automation-id': dataAutomationId || id } : {})}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            py: 8,
            ...sx,
        }}
    >
        <Grid container justifyContent="center" sx={{ width: '100%' }}>
            <Grid xs={xs} sm={sm} md={md} lg={lg} sx={{ backgroundColor: '#ffffff'}}>
                {children}
            </Grid>
        </Grid>
    </Box>
);

export default PageContainer;
